import { combineReducers } from 'redux';
import {
  INITIALIZE_COMPLETE, SET_UI_THEME,
  INITIALIZE_RESET,
  MASTER_DATA_FETCH_ERROR,
} from '../actions/constants';
import { defaultTheme } from 'src/design-system';
import masterData from './masterDataReducer';
import play from './playReducer';
import dashboard from './dashboardReducer';
import notificationsReducer from './notificationsReducer';
import navigation from './navigationReducer';
import exceptionRules from './exceptionRulesReducer';
import exceptionAlertDefinition from './exceptionAlertsDefinitionReducer';
import imports from './importsReducer';
import exports from './exportsReducer';
import user from './userManagementReducer';
import permissions from './permissionsReducer';
import logoutReducer from './logoutReducer';
import salesOrder from './salesOrderReducer';
import rfqReducer from './rfqReducer';
import biddingReducer from './biddingReducer';
import staticData from './staticDataReducer';
import summaryDashboardReducer from './summaryDashboardReducer';
import shipmentExecutionReducer from './shipmentExecutionReducer';
import biddingDetailsReducer from './biddingDetailsReducer';
import authUser from './authUser';
import inquiryFFReducer from './InquiryFFReducer';
const themeToSet = defaultTheme;
import inquiryReducer from './inquiryReducer';
import inquiryShipperReducer from './inquiryShipperReducer';
import inquiryFFBidsReducer from './inquiryFFBidsReducer';
import inquiryShipperBidsReducer from './inquiryShipperBidsReducer';
import bookingInquiryReducer from './bookingInquiryReducer';
import organisation from './organisationProfileReducer';
import activityMasterData from './activityMasterDataReducer';
import invoiceReducer from './invoiceReducer';
import invoiceActivity from './invoiceActivityReducer';
import teamsReducer from './teamsReducer';
import createPaginationReducers from './paginationReducers';
import rateMasterReducer from './rateMasterReducer';
import bulkRequestReducer from './bulkRequestReducer';
import discoverRatesReducer from './discoverRatesReducer';
import shipmentTrackingReducer from './shipmentTrackingReducer';
import dsrTemplateReducer from 'src/components/pages/masters/DsrTemplate/DsrTemplate.reducer';
import airCargoReducer from 'src/components/pages/AirCargo/AirCargo.reducer';
import markupAutomationToolReducer from
  'src/components/pages/MarkupAutomationTool/MarkupAutomationTool.reducer';
import vesselSchedulesReducer from 'src/components/pages/VesselSchedules/vesselSchedules.reducer';
import demurrageAndDetentionReducer from 'src/components/pages/DemurrageAndDetention/DemurrageAndDetention.reducer';
import tasksWorkflowReducer from 'src/components/pages/TasksWorkflow/TasksWorkflow.reducer';
import persistentIframe from './persistentIframeReducer';

const uiTheme = function (state = themeToSet, action) {

  switch (action.type) {
    case SET_UI_THEME: {
      return {
        ...themeToSet,
        ...action.data,
      };
    }

    default: return state;
  }
};

const initializing = function (state = true, action) {
  switch (action.type) {
    case INITIALIZE_COMPLETE:
      return false;
    case INITIALIZE_RESET:
      return true;

    default:
      return state;
  }
};

const defaultBootstrapConfig = {
  bootstrapError: null,
};
const bootstrapReducer = function (state = defaultBootstrapConfig, action) {
  switch (action.type) {
    case MASTER_DATA_FETCH_ERROR: {
      return {
        bootstrapError: action.errorMessage,
      };
    }
    default:
      return state;
  }
};

const CombinedReducers = combineReducers({
  uiTheme,
  initializing,
  bootstrapReducer,
  masterData,
  play,
  dashboard,
  bookingInquiryReducer,
  inquiryReducer,
  inquiryFFReducer,
  inquiryShipperReducer,
  inquiryFFBidsReducer,
  inquiryShipperBidsReducer,
  user,
  logoutReducer,
  navigation,
  exceptionRules,
  exceptionAlertDefinition,
  imports,
  permissions,
  rfqReducer,
  biddingDetailsReducer,
  biddingReducer,
  exports,
  salesOrder,
  staticData,
  authUser,
  dsrTemplateReducer,
  summaryDashboardReducer,
  shipmentExecutionReducer,
  organisation,
  activityMasterData,
  invoiceReducer,
  invoiceActivity,
  teamsReducer,
  ...createPaginationReducers(),
  rateMasterReducer,
  bulkRequestReducer,
  discoverRatesReducer,
  shipmentTrackingReducer,
  markupAutomationToolReducer,
  vesselSchedulesReducer,
  notificationsReducer,
  airCargoReducer,
  persistentIframe,
  demurrageAndDetentionReducer,
  tasksWorkflowReducer,
});

export type CombinedReducerTypes = ReturnType<typeof CombinedReducers>

export default CombinedReducers;
